import { Box, Chip, styled, Tooltip } from "@mui/material";
import { StyleguideSavioColors, StyleguideSavioFonts } from "../../../configuration/themeSettings";

export const TooltipContainer = styled("div", {
    label: "OfferOrderConditions-TooltipContainer ",
})(({ theme }) => ({
   '> h6':{
    color: StyleguideSavioColors.mainBlue,
    fontSize: 14,
    fontWeight: StyleguideSavioFonts.bold,
    textTransform: 'uppercase',
    backgroundColor: '#fff',
   },
   'table':{
    'tr':{
        height: 'auto',
        verticalAlign: 'baseline',

        '&:hover':{
            'td':{color: 'inherit !important',
                textDecoration: 'none !important',
                'p':{color: 'inherit !important',},
                '&:last-child':{
                    backgroundColor: '#fff',
                },
                '&:before':{
                    display: 'none !important',
                }
            }
        },
        
        'td':{
            padding: '5px 10px',
            borderBottom: '3px solid #fff !important',
            backgroundColor: '#fff',

            'p':{
                lineHeight: '15px',
                fontWeight: StyleguideSavioFonts.bold,
                
            },
            '&:first-of-type':{
                
                width: 190,
                'p':{textAlign: 'left',fontSize: 12,
                 
                    color: StyleguideSavioColors.text.black,
                    textTransform: 'uppercase',

                    '&:after':{
                        content: '":"',
                    }
                }
            },
            '&:last-child':{
              
                width: 260,

                'p':{
                    fontWeight: StyleguideSavioFonts.normal,
                    fontSize: 12,
                }
               
            },
            border: 'none',
            
        }
    }
   }
}));

export const TooltipStyled = styled(Tooltip, {
    label: "OfferOrderConditions-TooltipStyled ",
})(({ theme }) => ({
 
   }
));


export const BoxStyled = styled(Box, {
    label: "OfferOrderConditions-BoxStyled ",
})(({ theme }) => ({
    display: "flex", alignItems: "center",

    '> p':{
        fontSize: 12,
        '&:first-child':{
            textTransform: 'uppercase',

            '&:after':{
                content: '":"',
            }
        },
        '&:last-child':{

           paddingLeft: 10,
        }
    }
   }
));
